import React from 'react';
import { Navbar } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import Logo from '../../ui-library/Logo';

const Brand = () => (
  <LinkContainer to='/' exact>
    <Navbar.Brand>
      <Logo />
    </Navbar.Brand>
  </LinkContainer>
);

export default Brand;
